import { useMutation } from '@tanstack/react-query-v4'
import { useApi } from '@api/useApi.hook'
import { QueryKey } from '@api'
import { appConfig } from '@config'
import { queryClient } from '@providers/react-query'
import type { AddCartItemsInput } from './cart.types'

export const useAddCartItem = () => {
  const { post } = useApi()

  return useMutation({
    mutationFn: async ({ items }: AddCartItemsInput): Promise<void> => {
      await post(appConfig.endpoints.v1.cart.items, {
        disableAutoSnakeCase: true,
      })({
        items: items.map((item) => ({
          contractAddress: item.contractAddress,
          nftId: item.nftId,
        })),
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Cart] })
      await queryClient.invalidateQueries({ queryKey: [QueryKey.CartCount] })
    },
  })
}
